import React, { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import ExpenseSection from '../ExpenseSection/index.js';
import NotesSection from '../NotesSection/NotesSection.jsx';
import RemindersSection from '../RemindersSection/RemindersSection.jsx';
import TasksSection from '../TasksSection/TasksSection.jsx';
import FileSection from '../FileSection/FileSection.jsx';
import AgentMessagesSection from '../AgentMessagesSection/AgentMessagesSection.jsx';

const SECTIONS = {
  Expenses: {
    label: 'Expenses',
    Component: ExpenseSection
  },
  Files: {
    label: 'Files',
    Component: FileSection
  },
  'Meeting Notes': {
    label: 'Meeting Notes',
    Component: NotesSection
  },
  Reminders: {
    label: 'Reminders',
    Component: RemindersSection
  },
  'QDeck Tasks': {
    label: 'QDeck Tasks',
    Component: TasksSection
  },
  'Agent Messages': {
    label: 'Agent Messages',
    Component: AgentMessagesSection
  }
};

/**
 * @type {React.FC}
 */
const SidePanel = () => {
  const [selectedSection, setSelectedSection] = useState('Meeting Notes');

  const handleChange = (_event, newValue) => {
    setSelectedSection(newValue);
  };

  const Component = SECTIONS[selectedSection].Component;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '55%',
        ml: 2,
        verticalAlign: 'top'
      }}>
      <Tabs value={selectedSection} onChange={handleChange} indicatorColor='secondary'>
        {Object.keys(SECTIONS).map((label) => (
          <Tab key={label} label={label} value={label} />
        ))}
      </Tabs>
      {!!Component && <Component />}
    </Box>
  );
};

export default SidePanel;
